import { gql, TypedDocumentNode } from "@apollo/client";

import {
  DeleteRuleMutation,
  DeleteRuleMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";

export const deleteRuleMutation = gql(/* GraphQL */ `
  mutation DeleteRule($id: ID!) {
    deleteRule(id: $id)
  }
`) as TypedDocumentNode<DeleteRuleMutation, DeleteRuleMutationVariables>;
